var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:'button ' + _vm.btnClasses,attrs:{"href":_vm.href}},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }